import { render, staticRenderFns } from "./TicketsItem.vue?vue&type=template&id=42bc85f8&"
import script from "./TicketsItem.vue?vue&type=script&lang=js&"
export * from "./TicketsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports